<template>
  <div
    class="content-block honor-block"
    data-aos="fade-up"
    data-aos-duration="800"
    data-aos-delay="400"
  >
    <div class="block-left">
      <div class="block-number">07</div>
      <BlockHeader
        title="新闻资讯"
        subtitle="载誉前行，质铸口碑"
        subtitleEn="HONORS & QUALIFICATIONS"
      />
      <div class="block-ornament">
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
      </div>
    </div>
    <div class="block-right">
      <div class="news-container">
        <div class="news-main">
          <div class="news-featured">
            <div class="news-featured-image"></div>
            <div class="news-featured-content">
              <div class="news-date">
                <span class="day">19</span>
                <span class="month">7月</span>
                <span class="year">2025</span>
              </div>
              <h4>助力浙BA！太丰陪你燃爆球场，吃零食看比赛</h4>
              <p>浙BA赛程火热，舌尖与眼球双重狂欢！</p>
              <div class="news-bottom">
                <span class="news-label">浙BA</span>
                <span class="news-link" @click="onLink()">查看详情</span>
              </div>
            </div>
          </div>
        </div>
        <div class="news-sidebar">
          <div class="news-list">
            <div
              class="news-item"
              v-for="(honor, index) in honorList.slice().reverse()"
              :key="index"
            >
              <div
                class="news-item-link news-link"
                v-if="honor.link"
                @click="onLink(honor.link)"
              >
                查看详情
              </div>
              <div class="news-item-date">
                <span class="year">{{ honor.year }}</span>
              </div>
              <div class="news-item-content">
                <h5>{{ honor.title }}</h5>
                <p>{{ honor.description }}</p>
                <div class="news-meta">
                  <span class="award-level">{{ honor.level }}</span>
                  <span class="category">{{ honor.category }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="block-footer">
        <router-link :to="{ name: 'Honors' }" class="block-btn">
          <span>更多荣誉</span>
          <i class="fas fa-trophy"></i>
        </router-link>
      </div>-->
    </div>
  </div>
</template>

<script>
import BlockHeader from "../common/BlockHeader.vue";

export default {
  components: { BlockHeader },
  name: "HonorBlock",
  data() {
    return {
      honorList: [
        {
          year: "2021",
          title: '太丰荣获宁波市首批"宁波老字号"企业称号',
          description: "获得市级老字号官方认定",
          level: "市级认定",
          category: "官方认证",
        },
        {
          year: "2021",
          title: '太丰成为"淘宝黑马新商"',
          description: "电商平台认证的潜力新商家",
          level: "平台认证",
          category: "电商荣誉",
        },
        {
          year: "2022",
          title: "产品轻炙·原切牛肉片被评为宁波特色伴手礼",
          description: "代表宁波特色的优选产品",
          level: "特色产品",
          category: "产品奖项",
        },
        {
          year: "2022",
          title: '太丰荣获第十九届中国中华老字号精品博览会"品牌创新奖"',
          description: "在传统中创新，获得行业认可",
          level: "行业奖项",
          category: "创新奖",
        },
        {
          year: "2023",
          title: "荣获2023年度宁波市直播电商国潮新锐品牌",
          description: "在电商直播领域展现强大品牌实力",
          level: "市级荣誉",
          category: "品牌奖项",
        },
        {
          year: "2023",
          title: '被宁波老字号企业协会评为"金牌老字号"',
          description: "老字号协会认证的最高级别荣誉",
          level: "协会认证",
          category: "老字号",
        },
        {
          year: "2023",
          title: '被评选为"浙江老字号"',
          description: "获得省级老字号官方认定",
          level: "省级认定",
          category: "官方认证",
          link: "https://mp.weixin.qq.com/s/XwmfchZtjWcA6MFQAGWNdw",
        },
        {
          year: "2024",
          title: '太丰荣获第十三届宁波品牌双评选活动"最具竞争力品牌"',
          description: "在品牌竞争力评选中脱颖而出",
          level: "市级荣誉",
          category: "品牌奖项",
          link: "https://mp.weixin.qq.com/s/m7D39IPIFeUSbBkvBxhefg",
        },
        {
          year: "2024",
          title: '丰隆工厂荣获"2024年度江北区工程技术中心"称号',
          description: "在品牌竞争力评选中脱颖而出",
          level: "市级荣誉",
          category: "荣誉称号",
        },
        {
          year: "2024",
          title: '丰隆工厂入选宁波市2024年度"专精特新"中小企业拟认定名单',
          description: "在品牌竞争力评选中脱颖而出",
          level: "市级荣誉",
          category: "品牌奖项",
          link: "https://mp.weixin.qq.com/s/-aq2jld69jkiBPe4Vk8GuA",
        },
        {
          year: "2024",
          title: '太丰古法卤牛肉干获得"ISEE全球美味奖2星"',
          description: "2024年，太丰古法卤牛肉干凭借卓越品质荣获国际权威美食奖项",
          level: "国际奖项",
          category: "ISEE全球奖",
          link: "https://mp.weixin.qq.com/s/-uzMQmYWFQgshKp2RFfEzw",
        },
        {
          year: "2025",
          title: '太丰在第十四届宁波品牌双评选活动中，荣获"年度消费者信赖品牌"称号',
          description: "在品牌竞争力评选中脱颖而出",
          level: "市级荣誉",
          category: "荣誉称号",
          link: "https://mp.weixin.qq.com/s/nyhY6_6mOUukeYqx3BL7kg",
        },
        {
          year: "2025",
          title: '太丰食业亮相第112届全国糖酒商品交易会',
          description: "成都市中国西部国际博览城与您不见不散",
          level: "博览会",
          category: "太丰日程",
          link: "https://mp.weixin.qq.com/s/mlQ4O127kCsa__hF9DnRRw",
        },
        {
          year: "2025",
          title: '太丰食业亮相SIAL西雅国际食品和饮料展览会（上海）',
          description: "第23届SIAL INNOVATION 创新大赛入围产品正式出炉！",
          level: "国际食品展",
          category: "创新大赛",
          link: "https://mp.weixin.qq.com/s/nXtmll_xX87mKNJ3aAfJKQ",
        },
        {
          year: "2025",
          title: '太丰食品一期项目竣工交付',
          description: "7月21日，浙江太丰食品科技有限公司项目一期工程顺利通过验收",
          level: "一期工程",
          category: "定海工业园区",
          link: "https://mp.weixin.qq.com/s/H3ioQcJONPyOL_8Jxwux2Q",
        },

        ],
    };
  },
  methods: {
    onLink(url) {
      if (!url) {
        window.open("https://www.xiaohongshu.com/discovery/item/687b7a71000000002001a5be?source=webshare&xhsshare=pc_web&xsec_token=CBYHzWI2kBQWHCcoqTm96MxJBkkhPbhfxHttMwCDrjpUQ=&xsec_source=pc_share");
      } else {
        window.open(url);
      }
    },
  },
};
</script>

<style scoped>
.honor-block {
  display: flex;
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
  border-radius: 15px;
  margin-bottom: 40px;
  border: 1px solid rgba(154, 27, 30, 0.1);
  box-shadow: 0 8px 25px rgba(154, 27, 30, 0.08);
  overflow: hidden;
  position: relative;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.honor-block:hover {
  transform: translateY(-5px);
  border-color: rgba(154, 27, 30, 0.3);
  box-shadow: 0 15px 35px rgba(154, 27, 30, 0.12);
}

.honor-block .block-left {
  flex: 0 0 280px;
  padding: 35px 25px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(154, 27, 30, 0.05), transparent);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-right: 1px solid rgba(154, 27, 30, 0.1);
}

.honor-block .block-number {
  position: absolute;
  top: 15px;
  left: 15px;
  font-size: 3.5rem;
  font-weight: 900;
  color: rgba(154, 27, 30, 0.05);
  z-index: 0;
}

.honor-block .block-ornament {
  position: absolute;
  bottom: 25px;
  display: flex;
  gap: 6px;
}

.honor-block .ornament-item {
  width: 3px;
  height: 18px;
  background: linear-gradient(to top, #9a1b1e, transparent);
  border-radius: 1.5px;
}

.honor-block .ornament-item:nth-child(2) {
  height: 24px;
  background: linear-gradient(to top, #b22222, transparent);
}

.honor-block .ornament-item:nth-child(3) {
  height: 20px;
  background: linear-gradient(to top, #d32f2f, transparent);
}

.honor-block .block-right {
  flex: 1;
  padding: 35px 30px;
  position: relative;
  z-index: 1;
}

.honor-block .news-container {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 25px;
  margin: 25px 0;
}

.honor-block .news-featured {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(154, 27, 30, 0.1);
  height: 100%;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.03);
  transition: all 0.3s;
}

.honor-block .news-featured:hover {
  border-color: rgba(154, 27, 30, 0.3);
  box-shadow: 0 8px 25px rgba(154, 27, 30, 0.1);
  transform: translateY(-3px);
}

.honor-block .news-featured-image {
  height: 180px;
  background: linear-gradient(45deg, #9a1b1e, #b22222);
  position: relative;
  overflow: hidden;
}

.honor-block .news-featured-image::after {
  content: "TOP HONOR";
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(255, 255, 255, 0.9);
  color: #9a1b1e;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 0.7rem;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.honor-block .news-featured-image::before {
  content: "🏆";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 3rem;
  opacity: 0.3;
}

.honor-block .news-featured-content {
  padding: 25px;
}

.honor-block .news-date {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 15px;
}

.honor-block .news-date .day {
  font-size: 2rem;
  font-weight: 800;
  color: #9a1b1e;
}

.honor-block .news-date .month {
  font-size: 1rem;
  color: #666;
  font-weight: 700;
  text-transform: uppercase;
}

.honor-block .news-date .year {
  font-size: 0.9rem;
  color: #999;
}

.honor-block .news-featured h4 {
  font-size: 1.4rem;
  color: #222;
  margin-bottom: 12px;
  line-height: 1.3;
  font-weight: 700;
}

.honor-block .news-featured p {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
}

.honor-block .news-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.honor-block .news-label {
  display: inline-block;
  background: rgba(154, 27, 30, 0.1);
  color: #9a1b1e;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 600;
  border: 1px solid rgba(154, 27, 30, 0.2);
  transition: all 0.3s;
}

.honor-block .news-featured:hover .news-label {
  background: rgba(154, 27, 30, 0.15);
  border-color: rgba(154, 27, 30, 0.3);
}

.honor-block .news-link {
  color: #fff;
  background: #9a1b1e;
  padding: 5px 20px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s;
}
.honor-block .news-link:hover {
  color: #fff;

  transform: translateX(3px);
  box-shadow: 0 5px 15px rgba(154, 27, 30, 0.5);
}

.honor-block .news-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-height: 430px;
  overflow-y: auto;
  padding-right: 5px;
}

.honor-block .news-list::-webkit-scrollbar {
  width: 4px;
}

.honor-block .news-list::-webkit-scrollbar-track {
  background: rgba(154, 27, 30, 0.05);
  border-radius: 2px;
}

.honor-block .news-list::-webkit-scrollbar-thumb {
  background: rgba(154, 27, 30, 0.2);
  border-radius: 2px;
}

.honor-block .news-list::-webkit-scrollbar-thumb:hover {
  background: rgba(154, 27, 30, 0.3);
}

.honor-block .news-item {
  background: white;
  border-radius: 10px;
  padding: 18px;
  display: flex;
  gap: 12px;
  transition: all 0.3s;
  border: 1px solid rgba(154, 27, 30, 0.08);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  position: relative;
}

.honor-block .news-item:hover {
  background: rgba(154, 27, 30, 0.02);
  border-color: rgba(154, 27, 30, 0.2);
  transform: translateX(3px);
  box-shadow: 0 5px 15px rgba(154, 27, 30, 0.08);
}

.honor-block .news-item .news-item-link {
  position: absolute;
  top: 12px;
  right: 18px;
  font-size: 0.7rem;
  padding: 2px 10px;
}

.honor-block .news-item-date {
  flex: 0 0 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(154, 27, 30, 0.08);
  border-radius: 8px;
  padding: 8px;
  transition: all 0.3s;
  position: relative;
}

.honor-block .news-item-date::before {
  content: "★";
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  color: #9a1b1e;
  font-size: 0.8rem;
  opacity: 0;
  transition: opacity 0.3s;
}

.honor-block .news-item:hover .news-item-date::before {
  opacity: 1;
}

.honor-block .news-item:hover .news-item-date {
  background: rgba(154, 27, 30, 0.12);
}

.honor-block .news-item-date .year {
  font-size: 1.4rem;
  font-weight: 800;
  color: #9a1b1e;
  line-height: 1;
}

.honor-block .news-item-content {
  flex: 1;
}

.honor-block .news-item-content h5 {
  font-size: 1rem;
  color: #222;
  margin-bottom: 6px;
  line-height: 1.3;
  font-weight: 600;
}

.honor-block .news-item-content p {
  font-size: 0.85rem;
  color: #666;
  line-height: 1.4;
  margin-bottom: 8px;
}

.honor-block .news-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: #999;
}

.honor-block .news-meta .award-level {
  color: #9a1b1e;
  font-weight: 600;
  background: rgba(154, 27, 30, 0.1);
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.7rem;
}

.honor-block .news-meta .category {
  color: #666;
  font-weight: 500;
}

.honor-block .block-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.honor-block .block-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #9a1b1e, #b22222);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 700;
  transition: all 0.3s;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  box-shadow: 0 8px 20px rgba(154, 27, 30, 0.2);
  position: relative;
  overflow: hidden;
  text-decoration: none;
}

.honor-block .block-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s;
}

.honor-block .block-btn:hover {
  transform: translateX(5px);
  box-shadow: 0 12px 30px rgba(154, 27, 30, 0.3);
  color: white;
  text-decoration: none;
  background: linear-gradient(135deg, #b22222, #d32f2f);
}

.honor-block .block-btn:hover::before {
  left: 100%;
}

.honor-block .block-btn i {
  transition: transform 0.3s;
}

.honor-block .block-btn:hover i {
  transform: translateX(5px);
}

@media (max-width: 1200px) {
  .honor-block .block-left {
    flex: 0 0 250px;
  }
}

@media (max-width: 992px) {
  .honor-block {
    flex-direction: column;
  }

  .honor-block .block-left {
    flex: 0 0 auto;
    padding: 30px 25px;
    border-right: none;
    border-bottom: 1px solid rgba(154, 27, 30, 0.1);
  }

  .honor-block .block-right {
    padding: 30px 25px;
  }

  .honor-block .news-container {
    grid-template-columns: 1fr;
  }

  .honor-block .news-list {
    max-height: 300px;
  }
}

@media (max-width: 768px) {
  .honor-block .block-left {
    padding: 25px 20px;
  }

  .honor-block .block-right {
    padding: 25px 20px;
  }

  .honor-block .block-title {
    font-size: 1.6rem;
  }

  .honor-block .block-btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .honor-block .news-item {
    flex-direction: column;
  }

  .honor-block .news-item-date {
    flex-direction: row;
    justify-content: flex-start;
    gap: 10px;
    margin-bottom: 10px;
    width: 100%;
  }
}

.honor-block::after {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200px;
  height: 200px;
  background: radial-gradient(
    circle,
    rgba(154, 27, 30, 0.03) 0%,
    transparent 70%
  );
  z-index: 0;
}

.honor-block > * {
  position: relative;
  z-index: 1;
}
</style>
